import React from "react"
import PropTypes from "prop-types"
import WeeklyWritingTextArea from '../weekly_writing_prompts/WeeklyWritingTextArea'
import BtnPrimary from '../form_sections/BtnPrimary'
import BtnSecondary from '../form_sections/BtnSecondary'
import LoaderSection from '../app_components/LoaderSection'

class WeeklyWritingPrompt extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      writingText: '',
      selected: '',
      writeMoreError: false,
      showSuccessPage: false,
      languages: [],
      topic: [],
      responses: [],
      currentUser: '',
      btnLoading: false,
      loaded: false
    }
    this.renderLanguageOptions = this.renderLanguageOptions.bind(this)
    this.languageStyle = this.languageStyle.bind(this)
    this.buttonText = this.buttonText.bind(this)
    this.clickButton = this.clickButton.bind(this)
    this.updateWritingText = this.updateWritingText.bind(this)
    this.writeInAnotherLanguage = this.writeInAnotherLanguage.bind(this)
    this.removeLanguage = this.removeLanguage.bind(this)
    this.setLanguages = this.setLanguages.bind(this)
  }

  writeInAnotherLanguage() {
    this.setState({
      showSuccessPage: false
    })
  }

  updateWritingText(text) {
    this.setState({
      writingText: text,
      writeMoreError: false
    })
  }

  componentWillUnmount() {

    this.setState({
      selected: '',
      writingText: '',
      writeMoreError: false,
      btnLoading: false
    })
  }

  setLanguages() {
    let languages = this.state.languages
    this.setState({
      languages: languages,
      selected: languages[0],
      loaded: true
    })
    this.state.responses.map((resp, index) => {
      languages.map((lang, index) => {
        if(resp.language_id === lang.id) {
          languages.splice(index, 1)
          this.setState({
            languages: languages,
            selected: languages[0],
            loaded: true
          })
        }
      })
    })
  }

  removeLanguage(id) {
    let languages = this.state.languages
    languages.map((lang, index) => {
      if(id === lang.id) {
        languages.splice(index, 1)
        this.setState({
          languages: languages,
          selected: languages[0]
        })
      }
    })
  }

  componentDidMount() {
    $.ajax({
      url: `../dashboard_writing_practice`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          languages: data.data.languages,
          currentUser: data.data.currentUser,
          responses: data.data.responses,
          selected: data.data.languages[0],
          topic: data.data.writing_topic[0]
        }, () => this.setLanguages())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  languageStyle(id) {
    if(this.state.selected.id === id) {
      return {
        display: 'flex',
        height: 50,
        borderRadius: 30,
        backgroundColor: '#03A9F4',
        border: '#03A9F4 solid 3px',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 10,
        marginRight: 10,
        cursor: 'pointer',
        flex: '0 0 auto',
        padding: 10,
      }
    }
    return {
      display: 'flex',
      height: 50,
      width: 50,
      borderRadius: 30,
      border: '#03A9F4 solid 2px',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 10,
      marginRight: 10,
      cursor: 'pointer',
      flex: '0 0 auto'
    }
  }

  clickButton(lang) {
    if(this.state.selected.id === lang.id) {
      this.setState({
        btnLoading: true
      })
      if(this.state.writingText.length < 50) {
        this.setState({
          writeMoreError: true
        })
      } else {
        $.ajax({
          url: `../create_writing_response`,
          dataType: 'JSON',
          type: 'POST',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            body: this.state.writingText,
            language_id: this.state.selected.id,
            writing_topic_id: this.state.topic.id
          },
          success: (data) => {
            this.removeLanguage(this.state.selected.id)
            this.setState({
              showSuccessPage: true,
              btnLoading: false
            })
            return
          },
          error: function(xhr, status, err) {
            console.log(err)
          }.bind(this)
        });
      }
    } else {
      this.setState({
        selected: lang
      })
    }
  }

  renderLanguageOptions() {
    if(this.state.languages.length > 0) {
      return this.state.languages.map((lang, index) => {
        return(
          <div key={index} id={`btn${lang.id}`} style={this.languageStyle(lang.id)} onClick={() => this.clickButton(lang)}>
            <h4 className={this.state.selected.id === lang.id ? 'white' : 'lightBlue'}>{this.buttonText(lang)}</h4>
          </div>
        )
      })
    }
  }

  buttonText(lang) {
    if(this.state.selected.id === lang.id) {
      if(this.state.btnLoading != true) {
        return `Submit in ${lang.native}`
      }
    }
      return `${lang.locale}`
  }

  goToAllResponses() {
    window.location.assign("/weekly_writing_practice")
  }

  render() {
    if(!this.state.loaded) {
      return <LoaderSection />
    }
    if(this.state.showSuccessPage === true) {
      return(
        <div style={{margin: 12}}>
          <div style={{padding: 12, borderRadius: 3}}>
            <h4 style={{textAlign: 'center', fontWeight: 600, color: '#01579B'}}>Great Job!</h4>
            <h5 style={{textAlign: 'center', marginTop: 10, color: '#01579B'}}>You earned a Lexicoin!</h5>
            <div style={{textAlign: 'center', margin: 20}}>
              <img src={this.props.lexicoin} style={{width: 100, height: 100, borderRadius: 3}}/>
            </div>
            <div style={{width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', margin: 'auto', marginTop: 25, marginBottom: 15, maxWidth: 300}}>
              <BtnPrimary onClick={this.writeInAnotherLanguage} buttonText="Write in another language"/>
              <div style={{height: 10}}/>
              <BtnSecondary onClick={this.goToAllResponses} buttonText="Read other responses"/>
            </div>
          </div>
        </div>
      )
    } else if (this.state.languages.length < 1) {
      return(
        <div style={{margin: 12}}>
          <div style={{backgroundColor: 'rgba(255,255,255,.2)', padding: 12, borderRadius: 3}}>
            <h4 className='darkBlue' style={{textAlign: 'center', fontWeight: 600}}>Weekly Writing Practice</h4>
            <h5 className='darkBlue' style={{textAlign: 'center', marginTop: 10}}>Great job!</h5>
            <h5 className='darkBlue' style={{textAlign: 'center', marginBottom: 10}}>Check back every Sunday for a new prompt!</h5>
            <div style={{width: '100%', textAlign: 'center', marginTop: 40}}>
            <BtnPrimary onClick={this.goToAllResponses} buttonText="Read other responses" />
            </div>
          </div>
        </div>
      )
    }
    return(
      <div style={{margin: 12}}>
        <div style={{backgroundColor: 'rgba(255,255,255,.2)', padding: 12, borderRadius: 3}}>
          <h4 className='darkBlue' style={{textAlign: 'center', fontWeight: 600}}>Weekly Writing Practice</h4>
          <h5 className='darkBlue' style={{textAlign: 'center', marginTop: 10}}>Post your answers in each language.</h5>
          <h5 className='darkBlue' style={{textAlign: 'center', marginBottom: 10}}>Your answers will be added to your profile.</h5>
          <WeeklyWritingTextArea
              updateWritingText={this.updateWritingText}
              topic={this.state.topic}
              writeMoreError={this.state.writeMoreError}
              placeholder={`Write only in ${this.state.selected.native}.`}
          />
          <div style={{display: 'flex', flexDirection: 'row', marginTop: 12, overflow: 'scroll', whiteSpace: 'nowrap'}}>
            {this.renderLanguageOptions()}
          </div>
        </div>
      </div>
    )
  }

}

export default WeeklyWritingPrompt;
